<template>
  <div id="GoTop" @click="GoTop()">
    <span></span>
  </div>
</template>
<script>
export default {
  name: "GoTop",
  methods: {
    GoTop() {
      (function smoothscroll() {
        var currentScroll =
          document.documentElement.scrollTop || document.body.scrollTop;
        if (currentScroll > 0) {
          window.requestAnimationFrame(smoothscroll);
          window.scrollTo(0, currentScroll - currentScroll / 10);
        }
      })();
    }
  }
};
</script>
<style scoped>
#GoTop {
  width: 46px;
  height: 46px;
  position: fixed;
  right: 22px;
  bottom: 22px;
  z-index: 99;
  cursor: pointer;
  border-radius: 50%;
  border: 1px solid var(--ns-border-strong);
  background: #fff;
  box-shadow: 0 10px 24px rgba(59, 108, 255, 0.16);
}

#GoTop span {
  position: absolute;
  top: 18px;
  left: 15px;
  width: 14px;
  height: 14px;
  border-top: 2px solid var(--ns-cyan);
  border-left: 2px solid var(--ns-cyan);
  transform: rotate(45deg);
}
</style>



// WEBPACK FOOTER //
// src/components/GoTop.vue